import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
import { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
// features
import { getBranchConfigsByNamesSuccess } from '../branch/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature new-do
import * as A from './actions';
import { isValidCustomerRateForm } from './validation';
import {
  isPageCreateDO,
  getPrimaryReference,
  isSourceTypeEdiOrManual,
  createCustomerLoadNumber,
  getRateWithChargesFromData,
  getDivisionGuidByBranchConfigs,
  getStopPointsLatLonStringsArray,
} from './helpers';
import {
  TAB_NAME_BILL_TO,
  PAGE_TYPE_CREATE_DO,
  TAB_NAME_CLO_SUMMARY,
  PAGE_TYPE_CLO_TEMPLATE,
  PAGE_TYPE_LOAD_STOPS_EDIT,
  PAGE_TYPE_CREATE_FROM_EDI,
  PAGE_TYPE_CREATE_FROM_QUOTE,
  PAGE_TYPE_CREATE_FROM_PUBLIC_CLO,
  PAGE_TYPE_CREATE_FROM_ORDER_QUOTE,
} from './constants';
import {
  emptyStopFields,
  getNewItemFields,
  defaultBillToFields,
  getDefaultDropFields,
  allCustomerRateFields,
  getNewContainerFields,
  getDefaultPickupFields,
} from './settings/fields-settings';
//////////////////////////////////////////////////

const referenceFormInitData = {
  isValid: false,
  [GC.FIELD_LOAD_SERVICES]: [],
  [GC.FIELD_LOAD_REFERENCES]: [],
  [GC.FIELD_LOAD_EQUIPMENT]: null,
  [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS]: null,
};

const staticData = {
  branchList: [],
  fromPage: null,
  loadGuid: null,
  hotOrder: false,
  orderType: null,
  pinnedNote: null,
  branchRefTypes: {},
  divisionPrefix: '',
  divisionGuid: null,
  branchConfigs: null,
  telDriverRate: null,
  telCarrierRate: null,
  ignoreWarnings: false,
  saveAndDuplicateQty: 0,
  validationErrors: null,
  customerLoadNumber: '',
  stopPointsStrings: null,
  routeTemplateGuid: null,
  primaryRefSequence: null,
  validationWarnings: null,
  customerReferenceValue: '',
  sharedAccessorialsList: [],
  loadType: GC.LOAD_TYPE_CLO,
  indexedLocationTemplates: {},
  pageType: PAGE_TYPE_CREATE_DO,
  leftActiveTab: TAB_NAME_BILL_TO,
  branchInfo: GC.EMPTY_OPTION_OBJECT,
  rightActiveTab: TAB_NAME_CLO_SUMMARY,
  primaryReference: GC.EMPTY_OPTION_OBJECT,
  referenceFormData: referenceFormInitData,
  // For Containers
  useContainers: false,
  branchDefaultItem: null,
  addedNewFirstDrop: false,
  addedNewFirstPickup: false,
  autoCreateContainerItem: false,
};

const createDOData = {
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  ratePreviewFiles: null,
  prevStopsServiceGuids: null,
  pageType: PAGE_TYPE_CREATE_DO,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  telCreationMode: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
  //
  aiRecognize: {
    data: null,
    loading: false,
    parseDocument: null,
  },
  [GC.FIELD_TERMINAL_DROP]: {
    [GC.FIELD_LOCATION]: null,
    [GC.FIELD_LOAD_EVENT_LATE_DATE]: null,
    [GC.FIELD_LOAD_EVENT_EARLY_DATE]: null,
  },
};

const templateData = {
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  ratePreviewFiles: null,
  pageType: PAGE_TYPE_CLO_TEMPLATE,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  telCreationMode: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createFromEDIData = {
  ediData: null,
  ediFile: null,
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  [GC.FIELD_LOAD_TEL_CREATION_MODE]: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createFromPublicCloData = {
  rateBackup: null,
  publicCloData: null,
  [GC.FIELD_RATE]: null,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  pageType: PAGE_TYPE_CREATE_FROM_PUBLIC_CLO,
  [GC.FIELD_LOAD_TEL_CREATION_MODE]: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createFromOrderQuoteData = {
  orderQuoteData: {},
  [GC.FIELD_RATE]: null,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  pageType: PAGE_TYPE_CREATE_FROM_ORDER_QUOTE,
  [GC.FIELD_LOAD_TEL_CREATION_MODE]: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createFromQuoteData = {
  quoteData: null,
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  pageType: PAGE_TYPE_CREATE_FROM_QUOTE,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  [GC.FIELD_LOAD_TEL_CREATION_MODE]: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createNewDOPickup = (order) => ({
  order,
  isValid: false,
  id: G.generateGuid(),
  [GC.FIELD_DISTANCE_CLO]: null,
  formData: getDefaultPickupFields(),
  [GC.FIELD_EVENT_TYPE]: GC.EVENT_TYPE_PICKUP,
});

const createNewDODrop = (order) => ({
  order,
  isValid: false,
  id: G.generateGuid(),
  [GC.FIELD_DISTANCE_CLO]: null,
  formData: getDefaultDropFields(),
  [GC.FIELD_EVENT_TYPE]: GC.EVENT_TYPE_DROP,
});

const createExistedStopData = ({ event, loadType }) => {
  const eventType = R.prop(GC.FIELD_EVENT_TYPE, event);
  const orderProp = G.getEventIndexPropByLoadType(loadType);
  const distanceProp = G.getDistancePropByLoadType(loadType);
  const order = R.path([orderProp], event);
  const originDistance = R.path([distanceProp], event);
  const defaultFormFields = G.ifElse(
    G.isEventTypePickup(eventType),
    getDefaultPickupFields,
    getDefaultDropFields,
  )();

  return {
    order,
    eventType,
    isValid: false,
    originEvent: event,
    id: G.generateGuid(),
    formData: defaultFormFields,
    [distanceProp]: originDistance,
  };
};

const createNewStop = (stopType, stopOrder, branchDefaultItem, store) => {
  if (R.equals(stopType, GC.EVENT_TYPE_PICKUP)) {
    const newStop = createNewDOPickup(stopOrder);
    const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);

    let newFormData = R.mergeRight(newStop.formData, withDates);

    if (G.isNotNilAndNotEmpty(branchDefaultItem)) {
      const itemInternalId = G.generateGuid();
      const itemWithInternalId = R.assoc(GC.FIELD_ITEM_INTERNAL_ID, itemInternalId, branchDefaultItem);

      newFormData = R.assoc(GC.FIELD_LOAD_ITEMS, R.of(Array, itemWithInternalId), newFormData);
    }

    return R.assoc('formData', newFormData, newStop);
  }

  const newStop = createNewDODrop(stopOrder);
  const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
  const newFormData = R.mergeRight(newStop.formData, withDates);

  return R.assoc('formData', newFormData, newStop);
};

const createNewStopWithContainers = (stopType, stopOrder, store) => {
  const { branchDefaultItem } = store;

  if (R.equals(stopType, GC.EVENT_TYPE_PICKUP)) {
    const newStop = createNewDOPickup(stopOrder);
    const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
    const newFormData = R.mergeRight(newStop.formData, withDates);
    const firstPickupContainerInternalId = P.$get('stops.1.formData.pickedUpContainers.0.containerInternalId', store);
    const itemInternalId = G.generateGuid();
    const item = {
      ...branchDefaultItem,
      itemInternalId,
      containerInternalId: firstPickupContainerInternalId,
    };
    const formDataWithItem = R.assoc('items', R.of(Array, item), newFormData);

    return R.assoc('formData', formDataWithItem, newStop);
  }

  const newStop = createNewDODrop(stopOrder);
  const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
  const newFormData = R.mergeRight(newStop.formData, withDates);

  return R.assoc('formData', newFormData, newStop);
};

const pageTypeToInitialDataMap = {
  [PAGE_TYPE_CREATE_DO]: createDOData,
  [PAGE_TYPE_CLO_TEMPLATE]: templateData,
  [PAGE_TYPE_CREATE_FROM_EDI]: createFromEDIData,
  [PAGE_TYPE_CREATE_FROM_QUOTE]: createFromQuoteData,
  [PAGE_TYPE_CREATE_FROM_PUBLIC_CLO]: createFromPublicCloData,
  [PAGE_TYPE_CREATE_FROM_ORDER_QUOTE]: createFromOrderQuoteData,
};

const getInitialState = (pageType, sourceType = GC.CREATE_DO_SOURCE_TYPE_MANUAL) => {
  const pickup1 = createNewDOPickup(1);
  const drop1 = createNewDODrop(2);
  const initial = R.prop(pageType, pageTypeToInitialDataMap);
  const initData = R.mergeRight(staticData, initial);
  return R.mergeRight(
    initData,
    {
      sourceType,
      stops: {
        1: pickup1,
        2: drop1,
      },
    },
  );
};

const setValueToStore = (state, { path, value }) => (
  P.$set(path, value, state)
);

const setBranchBillTo = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const payTermsConfig = G.getConfigValueFromStore(GC.CLO_GENERAL_PAYMENT_TERMS, state.branchConfigs);
  const payTerms = G.ifElse(
    G.isNotNilAndNotEmpty(payTermsConfig),
    payTermsConfig,
    '',
  );

  const billTo = {
    ...data,
    'defaultBillTo': true,
    [GC.FIELD_PAYMENT_TERM]: payTerms,
    [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)),
  };

  return P.$set('billTo', billTo, state);
};

const setBranchShipFrom = (state, data) => {
  const formData = R.pathOr({}, ['stops', 1, 'formData'], state);
  const isAppointment = G.isNotNilAndNotEmpty(R.prop(GC.FIELD_APPOINTMENT_HOUR, data));
  const appointmentDate =  isAppointment ? R.propOr('', GC.FIELD_LOAD_EVENT_EARLY_DATE, formData) : '';
  const appointmentContact = R.prop(GC.FIELD_APPOINTMENT_CONTACT, data);

  return P.$set(
    'stops.1.formData',
    G.mapLocationHours({
      isAppointment,
      eventType: GC.EVENT_TYPE_PICKUP,
      ...R.mergeRight(
        R.mergeRight(R.pathOr({}, ['stops', 1, 'formData'], state), data),
        G.getBranchPickupDateTimeDefaultValues(state.branchConfigs),
      ),
      appointmentDate,
      [GC.FIELD_DROP_TRAILER]: R.prop(GC.FIELD_DROP_TRAILER, data),
      [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)),
      [GC.FIELD_APPOINTMENT_CONTACT]: R.isNil(appointmentContact) ? null : G.omitObjectSystemFields(appointmentContact),
    }),
    state,
  )
};

const setBranchShipTo = (state, data) => {
  const formData = R.pathOr({}, ['stops', 2, 'formData'], state);
  const isAppointment = G.isNotNilAndNotEmpty(R.prop(GC.FIELD_APPOINTMENT_HOUR, data));
  const appointmentDate =  isAppointment ? R.propOr('', GC.FIELD_LOAD_EVENT_EARLY_DATE, formData) : '';
  const appointmentContact = R.prop(GC.FIELD_APPOINTMENT_CONTACT, data);

  return P.$set(
    'stops.2.formData',
    G.mapLocationHours({
      isAppointment,
      eventType: GC.EVENT_TYPE_DROP,
      ...R.mergeRight(
        R.mergeRight(formData, data),
        G.getBranchDropDateTimeDefaultValues(state.branchConfigs),
      ),
      appointmentDate,
      [GC.FIELD_DROP_TRAILER]: R.prop(GC.FIELD_DROP_TRAILER, data),
      [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)),
      [GC.FIELD_APPOINTMENT_CONTACT]: R.isNil(appointmentContact) ? null : G.omitObjectSystemFields(appointmentContact),
    }),
    state,
  )
};

const setBranchDefaultItem = (state, data) => {
  let defaultItem = data;

  const configs = G.getItemFromWindow('amousNewDoBranchConfigs');
  const useContainers = G.isTrue(G.getConfigValueFromStore(GC.CLO_GENERAL_USE_CONTAINERS, configs));

  if (useContainers) {
    defaultItem = R.assoc(GC.FIELD_CONTAINER_INTERNAL_ID, '', defaultItem);
  }

  const palletSpaces = G.getPropFromObject(GC.FIELD_PALLET_SPACES, defaultItem);
  const billableWeight = G.getPropFromObject(GC.FIELD_BILLABLE_WEIGHT, defaultItem);

  if (R.and(palletSpaces, G.isNilOrEmpty(billableWeight))) {
    const configBillableWeight = G.getConfigValueFromStore(GC.CLO_ITEM_BILLABLE_WEIGHT_PER_PALLET_SPACE, configs);

    if (configBillableWeight) {
      defaultItem = R.assoc(
        GC.FIELD_BILLABLE_WEIGHT,
        G.calculateBillableWeight(palletSpaces, configBillableWeight),
        defaultItem,
      );
    }
  }

  const itemInternalId = G.generateGuid();
  const itemWithInternalId = R.assoc(GC.FIELD_ITEM_INTERNAL_ID, itemInternalId, defaultItem);
  const autoCreateContainerItem = G.getConfigValueFromStore(GC.CLO_GENERAL_AUTO_CREATE_CONTAINER_ITEM, configs);

  if (R.and(useContainers, autoCreateContainerItem)) {
    return P.$set('branchDefaultItem', defaultItem, state);
  }

  return P.$all(
    P.$set('branchDefaultItem', defaultItem),
    P.$set('stops.1.formData.items', R.of(Array, itemWithInternalId)),
    P.$set('stops.2.formData.items', R.of(Array, itemInternalId)),
    state,
  );
};

const setActiveLeftTab = (state, data) => (
  P.$set('leftActiveTab', data, state)
);

const setActiveRightTab = (state, data) => (
  P.$set('rightActiveTab', data, state)
);

const setNumberOfLoads = (state, data) => (
  P.$set('numberOfLoads', data, state)
);

const setTelCreationMode = (state, data) => (
  P.$set('telCreationMode', data, state)
);

const toggleHotOrder = (state) => (
  P.$toggle('hotOrder', state)
);

const stopApptsFields = [
  GC.FIELD_LOAD_FCFS,
  GC.FIELD_STOP_NUMBER,
  GC.FIELD_LOAD_EVENT_LATE_DATE,
  GC.FIELD_LOAD_EVENT_EARLY_DATE,
  GC.FIELD_LOAD_APPOINTMENT_DATE,
  GC.FIELD_LOAD_APPOINTMENT_NUMBER,
  GC.FIELD_LOAD_APPOINTMENT_REQUIRED,
  GC.FIELD_LOAD_APPOINTMENT_LATE_TIME,
  GC.FIELD_LOAD_APPOINTMENT_EARLY_TIME,
];

const stopDatesApptsFields = [
  GC.FIELD_LOAD_FCFS,
  GC.FIELD_STOP_NUMBER,
  GC.FIELD_LOAD_EVENT_LATE_TIME,
  GC.FIELD_LOAD_EVENT_LATE_DATE,
  GC.FIELD_LOAD_EVENT_EARLY_TIME,
  GC.FIELD_LOAD_EVENT_EARLY_DATE,
  GC.FIELD_LOAD_APPOINTMENT_DATE,
  GC.FIELD_LOAD_APPOINTMENT_NUMBER,
  GC.FIELD_LOAD_APPOINTMENT_REQUIRED,
  GC.FIELD_LOAD_APPOINTMENT_LATE_TIME,
  GC.FIELD_LOAD_APPOINTMENT_EARLY_TIME,
];


const getContainersFromEvent = (event) => {
  const droppedContainers = R.pathOr([], [GC.FIELD_STOP_DROPPED_CONTAINERS], event);
  const pickedUpContainers = R.pathOr([], [GC.FIELD_STOP_PICKED_UP_CONTAINERS], event);

  return { droppedContainers, pickedUpContainers };
};

const mapDataEvent = (event, withOutData = false) => {
  const {
    items,
    location,
    eventType,
    internalId,
    references,
    stopNumber,
    dropTrailer,
    cloEventIndex,
    appointmentContact,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
  } = event;

  const datesAppts = R.pick(stopDatesApptsFields, event);
  const containers = getContainersFromEvent(event);
  const createStopFunc = G.ifElse(
    G.isEventTypePickup(eventType),
    createNewDOPickup,
    createNewDODrop,
  );
  const itemsToUse = G.ifElse(
    G.isEventTypePickup(eventType),
    items,
    R.map((item) => R.prop(GC.FIELD_ITEM_INTERNAL_ID, item), items),
  );

  const init = createStopFunc(cloEventIndex);

  const contacts = G.getPropFromObject(GC.FIELD_CONTACTS, location);
  const state = G.getStateValueByConfig(R.prop(GC.FIELD_STATE, location));

  const contactsToUse = G.isNotNilAndNotEmpty(contacts)
    ? R.map(G.mapObjectNullFieldsToEmptyStrings, G.mapOmitObjectSystemFields(contacts))
    : contacts;

  if (withOutData) {
    const newFormData = {
      ...init.formData,
      ...G.resetLocationTypeFromDropdownOption(location),
      ...containers,
      state,
      dropTrailer,
      items: itemsToUse,
      droppedTrailerGuids,
      pickedUpTrailerGuids,
      contacts: contactsToUse,
    };

    return R.assoc('formData', G.mapObjectNullFieldsToEmptyStrings(newFormData), init);
  }

  const appointmentContactToUse = G.isNotNilAndNotEmpty(appointmentContact)
    ? G.mapObjectNullFieldsToEmptyStrings(appointmentContact)
    : init.formData.appointmentContact;

  const referencesToUse = G.isNotNilAndNotEmpty(references)
    ? R.map(G.mapObjectNullFieldsToEmptyStrings, references)
    : [];

  const newFormData = {
    ...init.formData,
    ...G.resetLocationTypeFromDropdownOption(location),
    ...datesAppts,
    ...containers,
    state,
    internalId,
    stopNumber,
    dropTrailer,
    items: itemsToUse,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
    contacts: contactsToUse,
    references: referencesToUse,
    appointmentContact: appointmentContactToUse,
  };

  return R.assoc('formData', G.mapObjectNullFieldsToEmptyStrings(newFormData), init);
};

const mapDataEvents = (events, withOutData = false) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  R.map((item) => mapDataEvent(item, withOutData)),
)(events);

const mapEdiEvents = R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  G.mapIndexed((event, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), mapDataEvent(event))),
);

const mapLoadStopsEditDataEvent = ({ event, loadType }) => {
  const {
    items,
    location,
    eventType,
    references,
    dropTrailer,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
  } = event;

  const appts = R.pick(stopApptsFields, event);
  const containers = getContainersFromEvent(event);
  const itemsToUse = G.ifElse(
    G.isEventTypePickup(eventType),
    items,
    R.map((item) => R.prop(GC.FIELD_ITEM_INTERNAL_ID, item), items),
  );
  const init = createExistedStopData({ event, loadType });

  const newFormData = {
    ...init.formData,
    ...G.resetLocationTypeFromDropdownOption(location),
    ...appts,
    ...containers,
    references,
    dropTrailer,
    items: itemsToUse,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
  };

  return R.assoc('formData', newFormData, init);
};

const mapLoadStopsEditDataEvents = ({ events, loadType }) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  R.map((event) => mapLoadStopsEditDataEvent({ event, loadType })),
)(events);

let quotePickupItems = [];

const getQuotePickupItems = (items) => {
  if (G.isNilOrEmpty(items)) return [];

  const itemsToUse = R.map(
    (item) => R.mergeRight(getNewItemFields(), item),
    items,
  );

  quotePickupItems = itemsToUse;

  return itemsToUse;
};

const getQuoteDropItems = () => {
  if (G.isNilOrEmpty(quotePickupItems)) return [];

  const items = R.map((item) => R.prop(GC.FIELD_ITEM_INTERNAL_ID, item), quotePickupItems);
  quotePickupItems = [];

  return items;
};

// TODO: check locationName from sequence here
const mapQuoteDataEvent = (event, index, items) => {
  const { location } = event;

  const eventEarlyDate = R.path([GC.FIELD_LOAD_EVENT_EARLY_DATE], event);
  const containers = getContainersFromEvent(event);
  const createStopFunc = G.ifElse(
    G.isZero(index),
    createNewDOPickup,
    createNewDODrop,
  );
  const itemsToUse = G.ifElse(
    G.isZero(index),
    getQuotePickupItems(items),
    getQuoteDropItems(),
  );
  const init = createStopFunc(R.inc(index));

  const newFormData = {
    ...init.formData,
    ...location,
    ...containers,
    items: itemsToUse,
    [GC.FIELD_LOAD_EVENT_EARLY_DATE]: eventEarlyDate,
  };

  return R.assoc('formData', newFormData, init);
};

const mapQuoteDataEvents = (events, items) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  G.mapIndexed((event, index) => mapQuoteDataEvent(event, index, items)),
)(events);

const getBillToFromData = (state, dataBillTo, branchConfigs) => {
  const { billTo } = state;

  const payTerms = G.getConfigValueFromStore(GC.CLO_GENERAL_PAYMENT_TERMS, branchConfigs);
  const billToWithTerms = R.assoc(GC.FIELD_PAYMENT_TERM, payTerms, billTo);

  if (G.isObject(dataBillTo)) {
    return G.resetLocationTypeFromDropdownOption({
      ...billToWithTerms,
      ...dataBillTo,
      defaultBillTo: true,
      [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, dataBillTo)),
    });
  }

  return G.resetLocationTypeFromDropdownOption(billToWithTerms);
};

const mapRateInitCharges = (rate) => {
  const charges = G.getChargesFromObject(rate);

  if (G.isNilOrEmpty(charges)) return rate;

  const chargesToUse = R.map(
    (item) => R.assoc(GC.FIELD_ID, R.or(G.getGuidFromObject(item), G.genShortId()), item),
    charges,
  );

  return R.assoc(GC.FIELD_CHARGES, chargesToUse, rate);
};

const getRateFromData = (rate, branchConfigs, isValid, equipmentServices) => {
  if (G.isNilOrEmpty(rate)) return null;

  const defaultEquipment = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_EQUIPMENT);
  const currency = G.getConfigValueFromStore(GC.GENERAL_BRANCH_DEFAULT_CURRENCY, branchConfigs);
  const mode = G.getConfigValueFromStore(GC.CLO_GENERAL_RATE_TRANSPORTATION_MODE, branchConfigs);

  const equipment = R.pathOr(
    defaultEquipment,
    [GC.FIELD_LOAD_EQUIPMENT, GC.FIELD_DROPDOWN_OPTION_GUID],
    equipmentServices,
  );

  const services = R.map(R.prop(GC.FIELD_DROPDOWN_OPTION_GUID), R.propOr([], GC.FIELD_SERVICES, equipmentServices));

  const init = {
    services,
    equipment,
    [GC.FIELD_MODE]: mode,
    isValid: R.or(isValid, false),
    [GC.FIELD_CURRENCY]: currency,
  };

  return R.mergeRight(init, mapRateInitCharges(rate));
};

const getTelCreationMode = (branchConfigs) => {
  const telCreationMode = G.getConfigValueFromStore(GC.CLO_GENERAL_TEL_CREATION_MODE, branchConfigs);

  return G.ifElse(
    G.isNotNilAndNotEmpty(telCreationMode),
    telCreationMode,
    GC.TEL_CREATION_MODE_SINGLE_TEL,
  );
};

const getBranchConfigsWithEdiSuccess = (state, data) => {
  const { ediData, branchGuid, branchConfigs } = data;

  const {
    clo: {
      rate,
      billTo,
      events,
      references,
      specialInstructions,
      internalInstructions,
      primaryReferenceValue,
    },
  } = ediData;

  const { branchList, branchRefTypes } = state;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);

  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };

  const divisionGuid = getDivisionGuidByBranchConfigs(branchConfigs, branchInfoMapped);
  const telCreationMode = getTelCreationMode(branchConfigs);
  const primaryReference = getPrimaryReference(branchConfigs, branchRefTypes);
  const defaultOrderType = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_ORDER_TYPE, branchConfigs);

  const additionalReferenceAutogenerated = G.getConfigValueFromStore(
    GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED,
    branchConfigs,
  );

  const additionalReferenceTypeGuid = G.getConfigValueFromStore(
    GC.CLO_ADDITIONAL_REFERENCE_TYPE,
    branchConfigs,
  );

  const ediPrimaryReference = R.find(R.propEq(true, GC.FIELD_PRIMARY), references);
  const hasEdiPrimaryReference = G.isNotNilAndNotEmpty(ediPrimaryReference);

  const referencesToUse = G.ifElse(
    hasEdiPrimaryReference,
    R.reject(R.propEq(true, GC.FIELD_PRIMARY), references),
    references,
  );

  const customerLoadNumber = hasEdiPrimaryReference
    ? R.prop(GC.FIELD_VALUE, ediPrimaryReference)
    : primaryReferenceValue;

  const mappedReferences = R.map((item) => {
    const { value, referenceTypeGuid } = item;

    if (G.isAllTrue(
      R.isNil(value),
      additionalReferenceAutogenerated,
      R.equals(referenceTypeGuid, additionalReferenceTypeGuid),
    )) return R.assoc('isAdditional', true, item);

    return item;
  }, referencesToUse);

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('ediData', ediData),
    P.$set('divisionGuid', divisionGuid),
    P.$set('orderType', defaultOrderType),
    P.$set('stops', mapEdiEvents(events)),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('telCreationMode', telCreationMode),
    P.$set('primaryReference', primaryReference),
    P.$set('pageType', PAGE_TYPE_CREATE_FROM_EDI),
    P.$set('customerLoadNumber', customerLoadNumber),
    P.$set('rate', getRateFromData(rate, branchConfigs)),
    P.$set('referenceFormData.references', mappedReferences),
    P.$set('rateBackup', getRateFromData(rate, branchConfigs)),
    P.$set('billTo', getBillToFromData(state, billTo, branchConfigs)),
    P.$set('referenceFormData.specialInstructions', specialInstructions),
    P.$set('referenceFormData.internalInstructions', internalInstructions),
    state,
  );
};

const getQuotePricing = (data) => {
  const { ratePrices, contactInfo, selectedPriceGuid } = data;

  if (G.isNilOrEmpty(ratePrices)) return null;

  const rate = R.find((field) => R.pathEq(selectedPriceGuid, ['price', GC.FIELD_GUID], field), ratePrices);

  if (G.isNilOrEmpty(rate)) return null;

  const { price, charges } = rate;

  const currency = R.path([GC.FIELD_CURRENCY], price);
  const transportationMode = R.path([GC.FIELD_MODE, GC.FIELD_DROPDOWN_OPTION_GUID], price);
  const serviceType = R.compose(
    R.path([GC.FIELD_DROPDOWN_OPTION_GUID]),
    R.path(['serviceTypes', 0]),
  )(price);
  const init = {
    ...contactInfo,
    charges,
    isValid: false,
    [GC.FIELD_CURRENCY]: currency,
    [GC.FIELD_MODE]: transportationMode,
    [GC.FIELD_SERVICE_TYPE]: serviceType,
  };

  return R.mergeRight(init, rate);
};

const getBranchConfigsWithQuoteSuccess = (state, data) => {
  const { quoteData } = data;
  const { items, lastEvent, firstEvent } = quoteData;

  const rate = getQuotePricing(quoteData);

  return P.$all(
    P.$set('rate', rate),
    P.$set('rateBackup', rate),
    P.$set('quoteData', quoteData),
    P.$set('pageType', PAGE_TYPE_CREATE_FROM_QUOTE),
    P.$set('stops', mapQuoteDataEvents([firstEvent, lastEvent], items)),
    P.$set('referenceFormData.specialInstructions', R.pathOr(null, [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS], quoteData)),
    state,
  );
};

const getReferenceFormDataFromTemplate = (template, branchConfigs) => {
  const additionalReferenceTypeGuid = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_TYPE, branchConfigs);
  const additionalReferenceAutogenerated = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED, branchConfigs);

  let references = R.map(
    (item) => R.pick([GC.FIELD_VALUE, GC.FIELD_REFERENCE_TYPE_GUID], item),
    R.pathOr([], [GC.FIELD_LOAD_REFERENCES], template),
  );

  if (additionalReferenceAutogenerated) {
    references = R.append(
      {
        isAdditional: true,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReferenceTypeGuid,
      },
      references,
    );
  }

  return {
    references,
    isValid: true,
    [GC.FIELD_LOAD_SERVICES]: R.map(
      (item) => R.prop(GC.FIELD_DROPDOWN_OPTION_GUID, item),
      R.pathOr([], [GC.FIELD_LOAD_SERVICES], template),
    ),
    [GC.FIELD_FAST_LOAD]: R.path([GC.FIELD_FAST_LOAD], template),
    [GC.FIELD_PINNED_NOTE]: R.path([GC.FIELD_PINNED_NOTE], template),
    [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS], template),
    [GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS], template),
    [GC.FIELD_LOAD_EQUIPMENT]: R.path([GC.FIELD_LOAD_EQUIPMENT, GC.FIELD_DROPDOWN_OPTION_GUID], template),
  };
};

const getBranchConfigsWithTemplateSuccess = (state, data) => {
  const { branchGuid, templateData, branchConfigs } = data;

  const { rate, billTo, events, services, equipment, orderType, divisionGuid } = templateData;

  const { branchList, sharedAccessorialsList } = state;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);

  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };


  const orderTypeToUse = G.getDropdownOptionGuidFromObject(orderType);

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('templateData', templateData),
    P.$set('divisionGuid', divisionGuid),
    P.$set('stops', mapDataEvents(events)),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('billTo', getBillToFromData(state, billTo, branchConfigs)),
    P.$set('telCreationMode', R.path([GC.FIELD_TEL_CREATION_MODE], templateData)),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], templateData)),
    P.$set('orderType', R.or(orderTypeToUse, G.getPropFromObject('orderType', state))),
    P.$set('referenceFormData', getReferenceFormDataFromTemplate(templateData, branchConfigs)),
    P.$set(
      'rate',
      getRateWithChargesFromData(rate, branchConfigs, false, sharedAccessorialsList, { services, equipment }),
    ),
    P.$set(
      'rateBackup',
      getRateWithChargesFromData(rate, branchConfigs, false, sharedAccessorialsList, { services, equipment }),
    ),
    state,
  );
};

const getBranchConfigsWithLoadStopsSuccess = (state, data) => {
  const { events, fromPage, loadGuid, loadType, branchGuid, branchConfigs } = data;

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('stopsData', data),
    P.$set('leftActiveTab', 1),
    P.$set('fromPage', fromPage),
    P.$set('loadGuid', loadGuid),
    P.$set('loadType', loadType),
    P.$set('branchInfo.value', branchGuid),
    P.$set('branchConfigs', branchConfigs),
    P.$set('pageType', PAGE_TYPE_LOAD_STOPS_EDIT),
    P.$set('stops', mapLoadStopsEditDataEvents({ events, loadType })),
    state,
  );
};

const mapEventsWithTimes = (events) => (
  R.map((item) => G.setEventEarlyLateTimeFromEarlyLateDate2(item),
  events,
));

const copyTemplateDataToStore = (state, data) => {
  const { branchConfigs, sharedAccessorialsList } = state;

  const { rate, billTo, events, services, equipment, orderType } = data;

  const eventsToUse = mapEventsWithTimes(events);

  const orderTypeToUse = G.getDropdownOptionGuidFromObject(orderType);

  return P.$all(
    P.$set('templateData', data),
    P.$set('stops', mapDataEvents(eventsToUse)),
    P.$set('billTo', getBillToFromData(state, billTo, branchConfigs)),
    P.$set('telCreationMode', R.path([GC.FIELD_TEL_CREATION_MODE], data)),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], data)),
    P.$set('orderType', R.or(orderTypeToUse, G.getPropFromObject('orderType', state))),
    P.$set('referenceFormData', getReferenceFormDataFromTemplate(data, branchConfigs)),
    P.$set(
      'rate',
      getRateWithChargesFromData(rate, branchConfigs, false, sharedAccessorialsList, { services, equipment }),
    ),
    P.$set(
      'rateBackup',
      getRateWithChargesFromData(rate, branchConfigs, false, sharedAccessorialsList, { services, equipment }),
    ),
    state,
  );
};

const applyLocationTemplatesData = (state, data) => {
  const { stops, indexedLocationTemplates } = state;

  const newTemplates = R.compose(
    R.mergeRight(indexedLocationTemplates),
    G.indexByGuid,
  )(data);

  const newStops = R.map(
    (stop) => {
      const { formData, eventType } = stop;

      const { templateGuid } = formData;

      const template = R.prop(templateGuid, newTemplates)

      if (R.or(G.isNilOrEmpty(templateGuid), R.isNil(template))) return stop;

      const appointmentContact = R.prop(GC.FIELD_APPOINTMENT_CONTACT, template);

      const newFormData = G.mapLocationHours({
        ...formData,
        ...R.pick([
          GC.FIELD_LOAD_FCFS,
          GC.FIELD_SHIPPING_HOUR,
          GC.FIELD_RECEIVING_HOUR,
          GC.FIELD_APPOINTMENT_HOUR,
          GC.FIELD_APPOINTMENT_COMMENTS,
        ], template),
        eventType,
        [GC.FIELD_REFERENCES]: R.pathOr([], [GC.FIELD_REFERENCES], formData),
        [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, formData)),
        [GC.FIELD_APPOINTMENT_CONTACT]: R.isNil(appointmentContact)
          ? G.getPropFromObject(GC.FIELD_APPOINTMENT_CONTACT, emptyStopFields)
          : G.omitObjectSystemFields(appointmentContact),
      });

      return R.assoc('formData', G.mapObjectNullFieldsToEmptyStrings(newFormData), stop);
    },
    stops,
  );

  return P.$all(
    P.$set('indexedLocationTemplates', newTemplates),
    P.$set('stops', newStops),
    state,
  );
};

const setItemOrContainer = (useContainers, branchConfigs, state) => {
  if (G.isTrue(useContainers)) {
    const withContainers = R.assocPath(
      [GC.FIELD_STOP_PICKED_UP_CONTAINERS, 0],
      getNewContainerFields(),
      state,
    );

    return R.assoc('items', [], withContainers);
  }

  return R.assocPath(
    ['items', 0],
    getNewItemFields(branchConfigs),
    state,
  );
};

const setDefaultLocationTypeToValues = (values, locationType) => {
  if (G.isNilOrEmpty(locationType)) return values;

  return R.assoc(GC.FIELD_LOCATION_TYPE, locationType, values);
};

const getBranchConfigsSuccess = (state, data) => {
  if (R.includes(
    state.pageType,
    [
      PAGE_TYPE_CLO_TEMPLATE,
      PAGE_TYPE_CREATE_FROM_EDI,
      PAGE_TYPE_CREATE_FROM_PUBLIC_CLO,
      PAGE_TYPE_CREATE_FROM_ORDER_QUOTE,
    ],
  )) return state;

  const { branchRefTypes } = state;

  const { branchConfigs } = data;

  const telCreationMode = getTelCreationMode(branchConfigs);

  const primaryReference = getPrimaryReference(branchConfigs, branchRefTypes);

  const useContainers = G.getConfigValueFromStore(GC.CLO_GENERAL_USE_CONTAINERS, branchConfigs);
  const autoCreateContainerItem = G.getConfigValueFromStore(GC.CLO_GENERAL_AUTO_CREATE_CONTAINER_ITEM, branchConfigs);
  const defaultReferences = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_REFERENCES, branchConfigs);
  const defaultEquipment = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_EQUIPMENT, branchConfigs);
  const defaultOrderType = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_ORDER_TYPE, branchConfigs);
  const defaultPickupLocationType = G.getConfigValueFromStore(GC.CLO_DEFAULT_PICKUP_LOCATION_TYPE, branchConfigs);
  const defaultSpecialInstruction = G.getConfigValueFromStore(GC.CLO_DEFAULT_SPECIAL_INSTRUCTION, branchConfigs);
  const defaultDropLocationType = G.getConfigValueFromStore(GC.CLO_DEFAULT_DROP_LOCATION_TYPE, branchConfigs);
  const additionalReference = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_TYPE, branchConfigs);
  const additionalReferencesAutogenerated = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED, branchConfigs);

  const withPickupDates = R.mergeRight(
    R.pathOr({}, ['stops', 1, 'formData'], state),
    setDefaultLocationTypeToValues(G.getBranchPickupDateTimeDefaultValues(branchConfigs), defaultPickupLocationType),
  );

  const withDefaultItemOrContainer = setItemOrContainer(useContainers, branchConfigs, withPickupDates);

  const withDropDates = R.mergeRight(
    R.pathOr({}, ['stops', 2, 'formData'], state),
    setDefaultLocationTypeToValues(G.getBranchDropDateTimeDefaultValues(branchConfigs), defaultDropLocationType),
  );

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  let references = [];

  if (G.isNotNilAndNotEmpty(defaultReferences)) {
    references = R.map((item) => ({
      [GC.FIELD_VALUE]: null,
      [GC.FIELD_REFERENCE_TYPE_GUID]: item,
    }), defaultReferences);
  }

  if (additionalReferencesAutogenerated) {
    references = R.append(
      {
        isAdditional: true,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReference,
      },
      references,
    );
  }

  return P.$all(
    P.$set('orderType', defaultOrderType),
    P.$set('useContainers', useContainers),
    P.$set('branchConfigs', branchConfigs),
    P.$set('stops.2.formData', withDropDates),
    P.$set('telCreationMode', telCreationMode),
    P.$set('primaryReference', primaryReference),
    P.$set('referenceFormData.references', references),
    P.$set('stops.1.formData', withDefaultItemOrContainer),
    P.$set('autoCreateContainerItem', autoCreateContainerItem),
    P.$set('billTo', getBillToFromData(state, null, branchConfigs)),
    P.$set('referenceFormData.equipment', R.or(defaultEquipment, null)),
    P.$set('referenceFormData.specialInstructions', R.or(defaultSpecialInstruction, null)),
    state,
  );
};

const getBranchConfigsOnQuoteSuccess = (state, data) => {
  const { branchConfigs } = data;
  const telCreationMode = getTelCreationMode(branchConfigs);
  const defaultReferences = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_REFERENCES, branchConfigs);
  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);
  if (G.isNotNilAndNotEmpty(defaultReferences)) {
    const references = R.map((item) => ({
      [GC.FIELD_VALUE]: null,
      [GC.FIELD_REFERENCE_TYPE_GUID]: item,
    }), defaultReferences);
    return P.$all(
      P.$set('branchConfigs', branchConfigs),
      P.$set('telCreationMode', telCreationMode),
      P.$set('referenceFormData.references', references),
      state,
    );
  }
  return P.$all(
    P.$set('branchConfigs', branchConfigs),
    P.$set('telCreationMode', telCreationMode),
    state,
  );
};

const getReferenceFormDataFromDuplicateDO = (data, branchConfigs) => {
  let references = [];
  const defaultEquipment = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_EQUIPMENT, branchConfigs);
  const defaultReferences = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_REFERENCES, branchConfigs);

  if (G.isNotNilAndNotEmpty(defaultReferences)) {
    references = R.map((item) => ({
      [GC.FIELD_VALUE]: null,
      [GC.FIELD_REFERENCE_TYPE_GUID]: item,
    }), defaultReferences);
  }

  const equipment = R.or(
    R.path([GC.FIELD_LOAD_EQUIPMENT, GC.FIELD_DROPDOWN_OPTION_GUID], data),
    R.or(defaultEquipment, null),
  );
  const services = R.map(
    (item) => R.prop(GC.FIELD_DROPDOWN_OPTION_GUID, item),
    R.pathOr([], [GC.FIELD_LOAD_SERVICES], data),
  );

  return ({
    isValid: true,
    [GC.FIELD_LOAD_SERVICES]: services,
    [GC.FIELD_LOAD_EQUIPMENT]: equipment,
    [GC.FIELD_LOAD_REFERENCES]: references,
    [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS], data),
    [GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS], data),
  });
};

const getBranchConfigsOnDuplicateDOSuccess = (state, data) => {
  const { branchGuid, branchConfigs, duplicateDOData } = data;

  const { rate, billTo, events } = duplicateDOData;

  const { branchList } = state;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);

  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('duplicateDO', duplicateDOData),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('stops', mapDataEvents(events, true)),
    P.$set('sourceType', GC.CREATE_DO_SOURCE_TYPE_COPY),
    P.$set('rate', getRateFromData(rate, branchConfigs, true)),
    P.$set('telCreationMode', getTelCreationMode(branchConfigs)),
    P.$set('rateBackup', getRateFromData(rate, branchConfigs, true)),
    P.$set('billTo', getBillToFromData(state, billTo, branchConfigs)),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], duplicateDOData)),
    P.$set('referenceFormData', getReferenceFormDataFromDuplicateDO(duplicateDOData, branchConfigs)),
    state,
  );
};

const setEdiFileToStore = (state, data) => (
  P.$set('ediFile', data, state)
);

const setRatePreviewFiles = (state, data) => {
  if (G.isNilOrEmpty(data)) {
    G.setItemToWindow('amousCreateDoRateConfirmationFiles', data);

    return P.$set('ratePreviewFiles', data, state);
  }

  const currentFiles = R.or(G.getItemFromWindow('amousCreateDoRateConfirmationFiles'), []);
  const files = R.concat(currentFiles, data);

  const filesWithPreview = R.map((file) => R.assoc('preview', URL.createObjectURL(file), file), files);

  G.setItemToWindow('amousCreateDoRateConfirmationFiles', files);

  return P.$set('ratePreviewFiles', filesWithPreview, state);
};

const setFormDataToStop = (state, data) => P.$all(
  P.$set(`stops.${data.stopOrder}.isValid`, data.isValid),
  P.$set(`stops.${data.stopOrder}.formData`, data.formData),
  state,
);

const setFormDataToStore = (state, data) => {
  const { dataName, formData } = data;

  if (R.equals(dataName, 'rate')) {
    return P.$all(
      P.$set('rate', formData),
      P.$set('rateBackup', formData),
      state,
    );
  }

  return P.$set(dataName, formData, state);
};

const setCustomerRateToStore = (state, data) => (
  P.$set('rate', data, state)
);

const setCustomerRateIsValidToStore = (state, data) => {
  const { rate, rateBackup } = state;

  if (G.isAnyNilOrEmpty([rate, rateBackup])) return state;

  return P.$all(
    P.$set('rate.isValid', data),
    P.$set('rateBackup.isValid', data),
    state,
  );
};

const setCustomerRateChargesToStore = (state, data) => {
  const { rate, telDriverRate, telCarrierRate } = state;

  if (G.isNilOrEmpty(rate)) {
    const fields = R.map(R.prop('fieldName'), allCustomerRateFields);
    const rate = R.assoc(
      GC.FIELD_CHARGES,
      data,
      R.pick(fields, R.or(telDriverRate, telCarrierRate)),
    );

    return P.$set('rate', rate, state);
  }

  return P.$all(
    P.$set('rate.charges', data),
    P.$set('rateBackup.charges', data),
    state,
  );
};

export const setCarrierRateToStore = (state, data) => {
  const { stops } = state;

  const { estimatedDeliveryEarlyDate, estimatedDeliveryLateDate } = data;

  const dropEarlyDate = P.$get('2.formData.eventEarlyDate', stops);
  const dropLateDate = P.$get('2.formData.eventLateDate', stops);

  const dropEventEarlyDate = R.or(estimatedDeliveryEarlyDate, dropEarlyDate);
  const dropEventLateDate = R.or(estimatedDeliveryLateDate, dropLateDate);

  const newStops = P.$all(
    P.$set('2.formData.eventEarlyDate', dropEventEarlyDate),
    P.$set('2.formData.eventLateDate', dropEventLateDate),
    stops,
  );

  return P.$all(
    P.$set('stops', newStops),
    P.$set('telCarrierRate', data, state),
  );
};

const setDriverRateToStore = (state, data) => (
  P.$set('telDriverRate', data, state)
);

const addNewStopToStore = (state, stopType) => {
  const {
    stops,
    pageType,
    sourceType,
    useContainers,
    branchDefaultItem,
    addedNewFirstDrop,
    addedNewFirstPickup,
    autoCreateContainerItem } = state;

  if (R.and(
    G.isAllTrue(
      useContainers,
      autoCreateContainerItem,
      isPageCreateDO(pageType),
      G.isEventTypePickup(stopType),
      isSourceTypeEdiOrManual(sourceType),
      G.isNotNilAndNotEmpty(branchDefaultItem),
    ),
    G.isAllFalse(
      addedNewFirstDrop,
      addedNewFirstPickup,
    ),
  )) {
    const stopOrder = 2;
    const stop = createNewStopWithContainers(stopType, stopOrder, state);
    const stopsWithAdded = R.insert(1, stop, R.values(stops));
    const newStops = R.compose(
      R.indexBy(R.prop(GC.FIELD_ORDER)),
      G.mapIndexed((stop, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), stop)),
    )(stopsWithAdded);
    const firstPickupContainerInternalId = P.$get('1.formData.pickedUpContainers.0.containerInternalId', newStops);
    const secondPickupItemInternalId = P.$get('2.formData.items.0.itemInternalId', newStops);
    const secondPickupEventEarlyDate = P.$get('2.formData.eventEarlyDate', newStops);
    const secondPickupEventLateDate = P.$get('2.formData.eventLateDate', newStops);
    const dropEventEarlyDate = P.$get('3.formData.eventEarlyDate', newStops);
    const dropEventLateDate = P.$get('3.formData.eventLateDate', newStops);
    const newStops2 = P.$all(
      P.$set('3.formData.items', R.of(Array, secondPickupItemInternalId)),
      P.$set('3.formData.droppedContainers', R.of(Array, firstPickupContainerInternalId)),
      P.$set('3.formData.eventEarlyDate', secondPickupEventEarlyDate),
      P.$set('3.formData.eventLateDate', secondPickupEventLateDate),
      P.$set('2.formData.eventEarlyDate', dropEventEarlyDate),
      P.$set('2.formData.eventLateDate', dropEventLateDate),
      newStops,
    );

    return P.$all(
      P.$set('stops', newStops2),
      P.$toggle('addedNewFirstPickup'),
      state,
    );
  }

  if (R.and(
    G.isAllTrue(
      useContainers,
      autoCreateContainerItem,
      isPageCreateDO(pageType),
      G.isEventTypeDrop(stopType),
      isSourceTypeEdiOrManual(sourceType),
      G.isNotNilAndNotEmpty(branchDefaultItem),
    ),
    G.isAllFalse(
      addedNewFirstDrop,
      addedNewFirstPickup,
    ),
  )) {
    const stopOrder = 3;
    const stop = createNewStopWithContainers(stopType, stopOrder, state);
    const stopsWithAdded = R.append(stop, R.values(stops));
    const newStops = R.compose(
      R.indexBy(R.prop(GC.FIELD_ORDER)),
      G.mapIndexed((stop, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), stop)),
    )(stopsWithAdded);
    const firstPickupContainerInternalId = P.$get('1.formData.pickedUpContainers.0.containerInternalId', newStops);
    const itemInternalId = G.generateGuid();
    const item = {
      ...branchDefaultItem,
      itemInternalId,
      containerInternalId: firstPickupContainerInternalId,
    };
    const newStops2 = P.$set('1.formData.items', R.of(Array, item), newStops);
    const newStops3 = P.$all(
      P.$set('2.formData.items', R.of(Array, itemInternalId)),
      P.$set('3.formData.droppedContainers', R.of(Array, firstPickupContainerInternalId)),
      newStops2,
    );

    return P.$all(
      P.$set('stops', newStops3),
      P.$toggle('addedNewFirstDrop'),
      state,
    );
  }

  const stopOrder = R.inc(R.length(R.values(state.stops)));
  const stop = createNewStop(stopType, stopOrder, branchDefaultItem, state);

  return P.$set(`stops.${stopOrder}`, stop, state);
};

const removeStopFromStore = (state, stopOrder) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    G.mapIndexed((item, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), item)),
    R.reject((item) => R.equals(R.prop(GC.FIELD_ORDER, item), stopOrder)),
    R.sortBy(R.prop(GC.FIELD_ORDER)),
    R.values(),
  )(state.stops);
  return P.$all(
    P.$set('stops', stops),
    P.$set('leftActiveTab', 1),
    state,
  );
};

const removeItemFromStore = (state, itemInternalId) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    R.map((stop) => {
      const { formData: { items }, eventType } = stop;

      if (G.isEventTypeDrop(eventType)) {
        const newItems = R.without([itemInternalId], items);

        return R.assocPath(['formData', GC.FIELD_LOAD_ITEMS], newItems, stop);
      }

      return stop;
    }),
    R.values(),
  )(state.stops);

  return P.$set('stops', stops, state);
};

const removeContainerFromStore = (state, { stopId, values, internalId }) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    R.map((stop) => {
      const { id, formData: { items, droppedContainers, pickedUpContainers } } = stop;

      const isCurrentStop = R.equals(id, stopId);
      const currentItems = G.ifElse(isCurrentStop, G.getPropFromObject(GC.FIELD_LOAD_ITEMS, values), items);

      const currentDroppedContainers = G.ifElse(
        isCurrentStop,
        G.getPropFromObject(GC.FIELD_STOP_DROPPED_CONTAINERS, values),
        droppedContainers,
      );

      const currentPickedUpContainers = G.ifElse(
        isCurrentStop,
        G.getPropFromObject(GC.FIELD_STOP_PICKED_UP_CONTAINERS, values),
        pickedUpContainers,
      );

      let newStop = isCurrentStop ? R.assoc('formData', values, stop) : stop;

      if (G.isNotNilAndNotEmpty(currentDroppedContainers)) {
        const newDroppedContainers = R.reject(
          R.either(R.equals(internalId), R.propEq(internalId, GC.FIELD_CONTAINER_INTERNAL_ID)),
          currentDroppedContainers,
        );

        newStop = R.assocPath(['formData', GC.FIELD_STOP_DROPPED_CONTAINERS], newDroppedContainers, newStop);
      }

      if (G.isNotNilAndNotEmpty(currentPickedUpContainers)) {
        const newPickedUpContainers = R.reject(
          R.propEq(internalId, GC.FIELD_CONTAINER_INTERNAL_ID),
          currentPickedUpContainers,
        );

        newStop = R.assocPath(['formData', GC.FIELD_STOP_PICKED_UP_CONTAINERS], newPickedUpContainers, newStop);
      }

      if (G.isNotNilAndNotEmpty(currentItems)) {
        const newItems = R.map((item) => {
          if (G.isObject(item)) {
            const { containerInternalId } = item;

            if (R.equals(internalId, containerInternalId)) {
              return R.mergeRight(item, {
                [GC.FIELD_CONTAINER_GUID]: null,
                [GC.FIELD_CONTAINER_NUMBER]: null,
                [GC.FIELD_CONTAINER_INTERNAL_ID]: '',
              });
            }
          }

          return item;
        }, currentItems);

        newStop = R.assocPath(['formData', GC.FIELD_LOAD_ITEMS], newItems, newStop);
      }

      return newStop;
    }),
    R.values(),
  )(state.stops);

  return P.$set('stops', stops, state);
};

const setReorderedStops = (state, data) => (
  P.$set('stops', data, state)
);

const recalculateLoadDistancesSuccess = (state, data) => {
  const { distance, stopPoints, mappedStops } = data;

  if (G.isNotNilAndNotEmpty(distance)) {
    const rate = R.mergeRight(state.rateBackup, distance);

    const rateWithValid = R.assoc('isValid', isValidCustomerRateForm(rate), rate);

    const stopPointsStrings = getStopPointsLatLonStringsArray(stopPoints);

    return P.$all(
      P.$set('stops', mappedStops),
      P.$set('rate', rateWithValid),
      P.$set('rateBackup', rateWithValid),
      P.$set('stopPointsStrings', stopPointsStrings),
      state,
    );
  }

  return P.$set('stops', mappedStops, state);
};

const getBranchListSuccess = (state, data) => (
  P.$set('branchList', data, state)
);

const getBranchStylingSuccess = (state, data) => (
  P.$set('styling', data, state)
);

const getPrimaryRefSequenceSuccess = (state, data) => P.$all(
  P.$set('primaryRefSequence', data),
  P.$set('customerLoadNumber', createCustomerLoadNumber({
    sequence: data,
    configs: state.branchConfigs,
    divisionPrefix: state.divisionPrefix,
  })),
  state,
);

const getAdditionalRefSequenceSuccess = (state, { data, duplicate }) => {
  const { branchConfigs } = state;

  const { prefix, suffix, approxValue } = data;

  const additionalReferenceValue = G.createStringFromArray([prefix, approxValue, suffix], '');

  if (duplicate) {
    const additionalReferenceTypeGuid = G.getConfigValueFromStore(
      GC.CLO_ADDITIONAL_REFERENCE_TYPE,
      branchConfigs,
    );

    const references = [
      {
        isAdditional: true,
        originalValue: additionalReferenceValue,
        [GC.FIELD_VALUE]: additionalReferenceValue,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReferenceTypeGuid,
      },
    ];

    return P.$set('referenceFormData.references', references, state);
  }

  const references = R.map((item) => {
    const { isAdditional } = item;

    if (isAdditional) {
      return {
        ...item,
        originalValue: additionalReferenceValue,
        [GC.FIELD_VALUE]: additionalReferenceValue,
      };
    }

    return item;
  }, R.pathOr([], ['referenceFormData', 'references'], state));

  return P.$set('referenceFormData.references', references, state);
};

const setCustomerLoadNumberByBranchConfigs = (state, { configs }) => {
  const divisionPrefix = G.getConfigValueFromStore(
    GC.CLO_PRIMARY_REFERENCE_DIVISION_PREFIX,
    configs,
  );

  return P.$all(
    P.$set('divisionPrefix', divisionPrefix),
    P.$set('customerLoadNumber', createCustomerLoadNumber({
      divisionPrefix,
      configs: state.branchConfigs,
      sequence: state.primaryRefSequence,
    })),
    state,
  );
};

const getAllAvBranchRefTypesSuccess = (state, { scopeName, data }) => (
  P.$set(`branchRefTypes.${scopeName}`, data, state)
);

const setCustomerLoadNumber = (state, value) => (
  P.$set('customerLoadNumber', value, state)
);

const setCustomerReferenceValue = (state, value) => (
  P.$set('customerReferenceValue', value, state)
);

const setDivisionGuid = (state, value) => (
  P.$set('divisionGuid', value, state)
);

const setPageTypeToStore = (state, value) => (
  P.$set('pageType', value, state)
);

const saveAndDuplicateSuccess = (state) => (
  P.$all(
    P.$set('ignoreWarnings', false),
    P.$set('validationWarnings', null),
    P.$set('customerReferenceValue', ''),
    P.$set('referenceFormData.references', []),
    P.$set('saveAndDuplicateQty', R.inc(state.saveAndDuplicateQty)),
    state,
  )
);

const setBranchInfo = (state, data) => G.ifElse(
  R.isNil(data),
  P.$set('branchInfo', GC.EMPTY_OPTION_OBJECT, state),
  P.$set('branchInfo', data, state),
);

const setPrimaryReference = (state, data) => (
  G.ifElse(
    R.isNil(data),
    P.$set('primaryReference', GC.EMPTY_OPTION_OBJECT, state),
    P.$set('primaryReference', data, state),
  )
);

const setValidationErrors = (state, data) => {
  if (G.isNotNilAndNotEmpty(data)) {
    return P.$set('validationErrors', data, state);
  }
  return state;
};

const setValidationErrorsAndWarnings = (state, { errors, warnings }) => (
  P.$all(
    P.$set('validationErrors', errors),
    P.$set('validationWarnings', warnings),
    state,
  )
);

const removeValidationErrors = (state) => (
  P.$set('validationErrors', null, state)
);

const removeValidationWarnings = (state) => (
  P.$set('validationWarnings', null, state)
);

const setIgnoreWarnings = (state, value = false) => (
  P.$all(
    P.$set('ignoreWarnings', value),
    P.$set('validationWarnings', G.ifElse(G.isTrue(value), null, state.validationWarnings)),
    state,
  )
);

const setInitialStateToStore = () => (
  getInitialState(PAGE_TYPE_CREATE_DO)
);

const cleanNewDOStore = (state, data) => {
  const guid = R.path([GC.FIELD_GUID], data);
  const pageType = R.pathOr(state.pageType, ['pageType'], data);
  const sourceType = G.getPropFromObject(GC.FIELD_SOURCE_TYPE, data);
  let customerInfo = GC.EMPTY_OPTION_OBJECT;
  if (G.isNotNil(guid)) {
    customerInfo = {
      value: guid,
      label: data[GC.FIELD_BRANCH_NAME],
    };
  }
  const branchList = P.$get('branchList', state);

  return P.$all(
    P.$set('branchList', branchList),
    P.$set('branchInfo', customerInfo),
    getInitialState(pageType, sourceType),
  );
};

const setPrevStopsServiceGuids = (state, data) => (
  P.$set('prevStopsServiceGuids', data, state)
);

// public clo
const mapPublicCloEvents = (events, allItems) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  G.mapIndexed((event, index) => {
    const {
      itemIds,
      location,
      eventType,
      references,
      containers,
      cloEventIndex,
      cloDistanceToNextStop } = event;

    const eventContainers = R.or(containers, []);
    const appts = R.pick(stopApptsFields, event);
    const createStopFunc = G.ifElse(
      G.isEventTypePickup(eventType),
      createNewDOPickup,
      createNewDODrop,
    );
    const itemsToUse = G.ifElse(G.isEventTypePickup(eventType), R.values(R.pick(itemIds, allItems)), itemIds);
    const containersToUse = G.ifElse(
      G.isEventTypePickup(eventType),
      eventContainers,
      R.map((item) => R.prop(GC.FIELD_CONTAINER_INTERNAL_ID, item), eventContainers),
    );
    const init = createStopFunc(cloEventIndex);
    const newFormData = {
      ...init.formData,
      ...event,
      ...G.resetLocationTypeFromDropdownOption(location),
      ...appts,
      references,
      order: index,
      items: itemsToUse,
      containers: containersToUse,
    };

    return {
      ...init,
      cloDistanceToNextStop,
      formData: newFormData,
    };
  }),
)(events);

const getBranchConfigsWithPublicCloDataSuccess = (state, data) => {
  if (G.isNilOrEmpty(R.path(['publicCloData', GC.FIELD_CLO], data))) return state;

  const { branchList, branchRefTypes } = state;
  const { branchGuid, branchConfigs, publicCloData } = data;
  const { clo: {
    rate,
    items,
    events,
    billTo,
    services,
    equipment,
    references,
    divisionGuid,
    specialInstructions,
    primaryReferenceValue } } = publicCloData;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);
  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };
  const telCreationMode = getTelCreationMode(branchConfigs);
  const primaryReference = getPrimaryReference(branchConfigs, branchRefTypes);
  const filteredReferences = R.filter(({ primary }) => G.isFalse(primary), references);
  const getPrimaryReferenceValue = R.compose(
    R.pathOr(primaryReferenceValue, [0, GC.FIELD_VALUE]),
    R.filter(R.prop(GC.FIELD_PRIMARY)),
  )(references);
  const allItems = R.indexBy(R.prop(GC.FIELD_ITEM_INTERNAL_ID), items);
  const stops = mapPublicCloEvents(events, allItems);
  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('stops', stops),
    P.$set('divisionGuid', divisionGuid),
    P.$set('publicCloData', publicCloData),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('telCreationMode', telCreationMode),
    P.$set('primaryReference', primaryReference),
    P.$set('pageType', PAGE_TYPE_CREATE_FROM_PUBLIC_CLO),
    P.$set('customerLoadNumber', getPrimaryReferenceValue),
    P.$set('referenceFormData.references', filteredReferences),
    P.$set('billTo', getBillToFromData(state, billTo, branchConfigs)),
    P.$set('referenceFormData.specialInstructions', specialInstructions),
    P.$set('rate', getRateFromData(rate, branchConfigs, { equipment, services })),
    P.$set('rateBackup', getRateFromData(rate, branchConfigs, { equipment, services })),
    P.$set('referenceFormData.equipment', G.getPropFromObject(GC.FIELD_DROPDOWN_OPTION_GUID, equipment)),
    P.$set('referenceFormData.services', R.map(R.prop(GC.FIELD_DROPDOWN_OPTION_GUID), R.or(services, []))),
    state,
  );
};

// order quote
const getBranchConfigsWithOrderQuoteDataSuccess = (state, data) => {
  if (G.isNilOrEmpty(R.path(['orderQuoteData'], data))) return state;

  const { branchList, branchRefTypes } = state;
  const { branchGuid, branchConfigs, orderQuoteData } = data;
  const {
    rate,
    guid,
    items,
    events,
    services,
    equipment,
    references,
    divisionGuid,
    telFleetRate,
    telCarrierRate,
    orderQuoteNumber,
    specialInstructions,
  } = orderQuoteData;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);
  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };
  const telCreationMode = getTelCreationMode(branchConfigs);
  const primaryReference = getPrimaryReference(branchConfigs, branchRefTypes);
  const filteredReferences = R.filter(({ primary }) => G.isFalse(primary), R.or(references, []));
  const allItems = R.indexBy(R.prop(GC.FIELD_ITEM_INTERNAL_ID), R.or(items, []));
  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('divisionGuid', divisionGuid),
    P.$set('telDriverRate', telFleetRate),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('telCarrierRate', telCarrierRate),
    P.$set('telCreationMode', telCreationMode),
    P.$set('primaryReference', primaryReference),
    P.$set('stops', mapPublicCloEvents(events, allItems)),
    P.$set('pageType', PAGE_TYPE_CREATE_FROM_ORDER_QUOTE),
    P.$set('referenceFormData.references', filteredReferences),
    P.$set('orderQuoteData', { orderQuoteNumber, orderQuoteGuid: guid }),
    P.$set('referenceFormData.specialInstructions', specialInstructions),
    P.$set('rate', getRateFromData(rate, branchConfigs, { equipment, services })),
    P.$set('rateBackup', getRateFromData(rate, branchConfigs, { equipment, services })),
    P.$set('referenceFormData.equipment', G.getPropFromObject(GC.FIELD_DROPDOWN_OPTION_GUID, equipment)),
    P.$set('referenceFormData.services', R.map(R.prop(GC.FIELD_DROPDOWN_OPTION_GUID), R.or(services, []))),
    state,
  );
};

const getBranchSharedAccessorialListSuccess = (state, data) => (
  P.$set('sharedAccessorialsList', data, state)
);

// transportation mode grouping
const getTransportationModeGroupingListSuccess = (state, data) => (
  P.$set('transportationModeGroupingList', R.indexBy(R.prop(GC.FIELD_TRANSPORTATION_MODE_GUID), R.or(data, [])), state)
);

// ai recognize
let recognizeEventPickupItems = [];

const getRecognizeEventPickupItems = (items, itemIds) => {
  if (R.or(G.isNilOrEmpty(items), G.isNilOrEmpty(itemIds))) return [];

  const itemsToUse = R.compose(
    R.map((item) => R.mergeRight(getNewItemFields(), item)),
    R.filter(({ itemInternalId }) => R.includes(itemInternalId, itemIds)),
  )(items);

  recognizeEventPickupItems = itemsToUse;

  return itemsToUse;
};

const getRecognizeEventDropItems = (itemIds) => {
  if (R.or(G.isNilOrEmpty(recognizeEventPickupItems), G.isNilOrEmpty(itemIds))) return [];

  const items = R.compose(
    R.map((item) => R.prop(GC.FIELD_ITEM_INTERNAL_ID, item)),
    R.filter(({ itemInternalId }) => R.includes(itemInternalId, itemIds)),
  )(recognizeEventPickupItems);

  recognizeEventPickupItems = [];

  return items;
};

const getRecognizeEventContainers = (containers, pickedUpContainerIds, droppedContainerIds) => {
  let droppedContainers = [];
  let pickedUpContainers = [];

  const useContainers = G.getAmousConfigByNameFromWindow(GC.CLO_GENERAL_USE_CONTAINERS);

  if (G.isAnyTrue(
    G.isNilOrEmpty(containers),
    G.isNilOrFalse(useContainers),
    G.isAllNilOrEmpty([droppedContainerIds, pickedUpContainerIds]),
  )) {
    return { droppedContainers, pickedUpContainers };
  }

  if (G.isNotNilAndNotEmpty(pickedUpContainerIds)) {
    const containerTypes = G.getAmousContainerTypeListFromWindow();

    pickedUpContainers = R.compose(
      R.map((container) => {
        let containerToUse = container;

        const containerType = R.find(R.propEq(R.prop('containerTypeName', container), GC.FIELD_NAME), containerTypes);

        if (G.isNotNilAndNotEmpty(containerType)) {
          const typeValues = R.pick([
            GC.FIELD_WIDTH,
            GC.FIELD_HEIGHT,
            GC.FIELD_LENGTH,
            GC.FIELD_WEIGHT_UOM,
            GC.FIELD_DIMENSIONS_UOM,
            GC.FIELD_EMPTY_CONTAINER_WEIGHT,
          ], containerType);

          const containerWeightUom = R.prop(GC.FIELD_WEIGHT_UOM, container);
          const fullContainerWeight = R.prop(GC.FIELD_FULL_CONTAINER_WEIGHT, container);

          containerToUse = R.mergeAll([
            container,
            typeValues,
            {
              [GC.FIELD_CONTAINER_TYPE_GUID]: G.getGuidFromObject(containerType),
              [GC.FIELD_FULL_CONTAINER_WEIGHT]: R.or(
                fullContainerWeight,
                R.prop(GC.FIELD_EMPTY_CONTAINER_WEIGHT, containerType),
              ),
              [GC.FIELD_WEIGHT_UOM]: G.ifElse(
                G.isAllNotNilOrNotEmpty([containerWeightUom, fullContainerWeight]),
                containerWeightUom,
                R.prop(GC.FIELD_WEIGHT_UOM, containerType),
              ),
            }
          ]);
        }

        return R.mergeRight(getNewContainerFields(), containerToUse);
      }),
      R.filter(({ containerInternalId }) => R.includes(containerInternalId, pickedUpContainerIds)),
    )(containers);
  }

  if (G.isNotNilAndNotEmpty(droppedContainerIds)) {
    droppedContainers = R.compose(
      R.map(R.prop(GC.FIELD_CONTAINER_INTERNAL_ID)),
      R.filter(({ containerInternalId }) => R.includes(containerInternalId, droppedContainerIds)),
    )(containers);
  }

  return { droppedContainers, pickedUpContainers };
};

const mapRecognizeEvent = (event, index, items, containers) => {
  const {
    itemIds,
    comments,
    location,
    eventType,
    eventLateDate,
    eventEarlyDate,
    droppedContainerIds,
    pickedUpContainerIds,
  } = event;

  let contacts = R.pathOr([], [GC.FIELD_CONTACTS], location);

  if (R.not(G.isArray(contacts))) {
    contacts = [];
  } else {
    contacts = R.map((contact) => {
      const phone = contact?.phone;

      if (G.isNotNilAndNotEmpty(phone)) {

        if (isValidPhoneNumber(phone)) return contact;

        const parsed = parsePhoneNumber(phone, 'US');

        const number = parsed?.number;

        if (G.isNilOrEmpty(number)) return contact;

        if (isValidPhoneNumber(number)) return R.assoc(GC.FIELD_PHONE, number, contact);
      }

      return contact;
    }, contacts);
  }

  const createStopFunc = G.ifElse(
    G.isEventTypePickup(eventType),
    createNewDOPickup,
    createNewDODrop,
  );

  const itemsToUse =
    G.isEventTypePickup(eventType) ?
    getRecognizeEventPickupItems(items, itemIds) :
    getRecognizeEventDropItems(itemIds);

  const eventContainers = getRecognizeEventContainers(containers, pickedUpContainerIds, droppedContainerIds);

  const init = createStopFunc(R.inc(index));

  // TODO: check with API if all contacts data empty
  const newFormData = {
    ...init.formData,
    ...location,
    ...eventContainers,
    contacts,
    comments,
    eventLateDate,
    eventEarlyDate,
    items: itemsToUse,
  };

  return R.assoc('formData', newFormData, init);
};

export const mapRecognizeStopsData = (events, items, containers) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  G.mapIndexed((event, index) => mapRecognizeEvent(event || {}, index, items, containers)),
)(events);

const mapRecognizeRateInitCharges = (rate) => {
  const charges = G.getChargesFromObject(rate);

  if (G.isNilOrEmpty(charges)) return rate;

  const chargesToUse = R.map(
    (item) => {
      const id = R.or(G.getGuidFromObject(item), G.genShortId());
      // TODO: check default storedValue with API
      const storedValue = R.or(G.getPropFromObject(GC.FIELD_STORED_VALUE, item), G.genShortId());

      return {
        ...item,
        [GC.FIELD_ID]: id,
        [GC.FIELD_STORED_VALUE]: storedValue,
      };
    },
    charges,
  );

  return R.assoc(GC.FIELD_CHARGES, chargesToUse, rate);
};

export const getRateFromRecognizeData = (rate, branchConfigs) => {
  if (G.isNilOrEmpty(rate)) return null;

  const currency = G.getConfigValueFromStore(GC.GENERAL_BRANCH_DEFAULT_CURRENCY, branchConfigs);
  const mode = G.getConfigValueFromStore(GC.CLO_GENERAL_RATE_TRANSPORTATION_MODE, branchConfigs);

  const init = {
    isValid: false,
    [GC.FIELD_MODE]: mode,
    [GC.FIELD_CURRENCY]: currency,
  };

  return R.mergeDeepRight(init, mapRecognizeRateInitCharges(rate));
};

export const getBillToFromRecognizeData = (state, dataBillTo) => {
  const { billTo } = state;

  if (G.isTrue(G.getPropFromObject('defaultBillTo', billTo))) return billTo;

  let billToUse = G.assign(dataBillTo);

  if (G.isObject(dataBillTo)) {
    const { emails } = dataBillTo;

    const init = R.pick([GC.FIELD_COUNTRY, GC.FIELD_PAYMENT_TERM], billTo);

    // TODO: with validation all cases
    if (R.propEq('USA', GC.FIELD_COUNTRY, billToUse)) {
      billToUse = { ...billToUse, [GC.FIELD_COUNTRY]: 'United States' };
    }

    const finalBillToUse = R.assoc('emails', (emails || []).filter(Boolean), billToUse);

    return G.mergeWithoutNullUndefinedOrEmptyString(init, finalBillToUse);
  }

  return billTo;
};

const aiRecognizeSuccess = (state, data) => {
  try {
    const { branchConfigs } = state;

    const {
      rate,
      items,
      notes,
      billTo,
      events,
      containers,
      specialInstructions,
    } = data;

    const stops = mapRecognizeStopsData(events || [], items || [], containers || []);

    const rateToUse = getRateFromRecognizeData(rate, branchConfigs);

    const billToUse = getBillToFromRecognizeData(state, billTo);

    return P.$all(
      P.$set('aiRecognize.data', data),
      //
      P.$set('rate', rateToUse),
      P.$set('rateBackup', rateToUse),
      //
      P.$set('stops', stops),
      P.$set('billTo', billToUse),
      //
      P.$set('referenceFormData.pinnedNote', notes),
      P.$set('referenceFormData.specialInstructions', specialInstructions),
      state,
    );
  } catch (error) {
    G.handleException(error, 'aiRecognizeSuccess exception');

    return state;
  }
};

const fetchStopLatLonSuccess = (state, payload) => {
  const { data, stopIndex } = payload;

  const { latitude, longitude } = data;

  if (G.isAllTrue(
    G.isNotNilAndNotEmpty(latitude),
    G.isNotNilAndNotEmpty(longitude),
    G.isNotNilAndNotEmpty(stopIndex),
  )) {
    const currentFormData = P.$get(`stops.${stopIndex}.formData`, state);

    const formData = R.mergeDeepRight(currentFormData, data);

    return P.$set(`stops.${stopIndex}.formData`, formData, state);
  }

  return state;
};
// ai recognize

// calculate eta
export const calculateEtaSuccess = (state, data) => {
  const { stops, pageType } = state;

  const { legs, totalDuration, currentPageType, etaCalculationParams } = data;

  if (G.notEquals(pageType, currentPageType)) return state;

  const formattedTotalDuration = G.getFormattedDurationFromString(totalDuration);

  const addDurationToDate = (date, duration) => {
    if (R.or(G.isNilOrEmpty(date), G.isNilOrEmpty(duration))) return date;

    return G.checkAndConvertMomentInstanceOrStringToFormattedDate(
      G.addDurationToDate(date, duration),
      GC.DEFAULT_DATE_TIME_FORMAT,
    );
  };

  let mappedStops = {};

  R.forEach((item) => {
    const { order } = item;

    if (R.equals(order, 1)) {
      const newStop = R.assocPath(['formData', GC.FIELD_ESTIMATED_TIME_OF_ARRIVAL], null, item);

      mappedStops = R.assoc(order, newStop, mappedStops);

      return;
    }

    const index = R.subtract(order, 2);
    const duration = R.path([index, 'duration'], legs);
    const prevEventEarlyDate = R.pathOr('', [R.dec(order), 'formData', GC.FIELD_LOAD_EVENT_EARLY_DATE], mappedStops);
    const estimatedTimeOfArrival = addDurationToDate(prevEventEarlyDate, duration);
    const newStop = R.assocPath(['formData', GC.FIELD_ESTIMATED_TIME_OF_ARRIVAL], estimatedTimeOfArrival, item);

    mappedStops = R.assoc(order, newStop, mappedStops);
  }, R.values(stops));

  return P.$all(
    P.$set('stops', mappedStops),
    P.$set('etaCalculationParams', etaCalculationParams),
    P.$set('etaCalculationResult', { ...R.dissoc('etaCalculationParams', data), formattedTotalDuration }),
    state,
  );
};

const setETAConfigList = (state, data) => (
  P.$set('etaConfigList', data, state)
);

export default createReducer({
  [A.setBranchInfo]: setBranchInfo,
  [A.toggleHotOrder]: toggleHotOrder,
  [A.setDivisionGuid]: setDivisionGuid,
  [A.setBranchShipTo]: setBranchShipTo,
  [A.cleanNewDOStore]: cleanNewDOStore,
  [A.setBranchBillTo]: setBranchBillTo,
  [A.setValueToStore]: setValueToStore,
  [A.setNumberOfLoads]: setNumberOfLoads,
  [A.setActiveLeftTab]: setActiveLeftTab,
  [A.setEdiFileToStore]: setEdiFileToStore,
  [A.setActiveRightTab]: setActiveRightTab,
  [A.setBranchShipFrom]: setBranchShipFrom,
  [A.setReorderedStops]: setReorderedStops,
  [A.setFormDataToStop]: setFormDataToStop,
  [A.addNewStopToStore]: addNewStopToStore,
  [A.setIgnoreWarnings]: setIgnoreWarnings,
  [A.setPageTypeToStore]: setPageTypeToStore,
  [A.setFormDataToStore]: setFormDataToStore,
  [A.setTelCreationMode]: setTelCreationMode,
  [A.setRatePreviewFiles]: setRatePreviewFiles,
  [A.removeItemFromStore]: removeItemFromStore,
  [A.setValidationErrors]: setValidationErrors,
  [A.removeStopFromStore]: removeStopFromStore,
  [A.setPrimaryReference]: setPrimaryReference,
  [A.setBranchDefaultItem]: setBranchDefaultItem,
  [A.getBranchListSuccess]: getBranchListSuccess,
  [A.setDriverRateToStore]: setDriverRateToStore,
  [A.setCarrierRateToStore]: setCarrierRateToStore,
  [A.setCustomerLoadNumber]: setCustomerLoadNumber,
  [A.setInitialStateToStore]: setInitialStateToStore,
  [A.removeValidationErrors]: removeValidationErrors,
  [A.setCustomerRateToStore]: setCustomerRateToStore,
  [A.saveAndDuplicateSuccess]: saveAndDuplicateSuccess,
  [A.getBranchStylingSuccess]: getBranchStylingSuccess,
  [A.getBranchConfigsSuccess]: getBranchConfigsSuccess,
  [A.copyTemplateDataToStore]: copyTemplateDataToStore,
  [A.removeContainerFromStore]: removeContainerFromStore,
  [A.removeValidationWarnings]: removeValidationWarnings,
  [A.setPrevStopsServiceGuids]: setPrevStopsServiceGuids,
  [A.setCustomerReferenceValue]: setCustomerReferenceValue,
  [A.applyLocationTemplatesData]: applyLocationTemplatesData,
  [A.getPrimaryRefSequenceSuccess]: getPrimaryRefSequenceSuccess,
  [A.setCustomerRateIsValidToStore]: setCustomerRateIsValidToStore,
  [A.setCustomerRateChargesToStore]: setCustomerRateChargesToStore,
  [A.getAllAvBranchRefTypesSuccess]: getAllAvBranchRefTypesSuccess,
  [A.getBranchConfigsOnQuoteSuccess]: getBranchConfigsOnQuoteSuccess,
  [A.getBranchConfigsWithEdiSuccess]: getBranchConfigsWithEdiSuccess,
  [A.setValidationErrorsAndWarnings]: setValidationErrorsAndWarnings,
  [A.getAdditionalRefSequenceSuccess]: getAdditionalRefSequenceSuccess,
  [A.recalculateLoadDistancesSuccess]: recalculateLoadDistancesSuccess,
  [A.getBranchConfigsWithQuoteSuccess]: getBranchConfigsWithQuoteSuccess,
  [A.getBranchConfigsWithTemplateSuccess]: getBranchConfigsWithTemplateSuccess,
  [A.getBranchConfigsOnDuplicateDOSuccess]: getBranchConfigsOnDuplicateDOSuccess,
  [A.getBranchConfigsWithLoadStopsSuccess]: getBranchConfigsWithLoadStopsSuccess,
  [A.getBranchSharedAccessorialListSuccess]: getBranchSharedAccessorialListSuccess,
  // branch configs
  [getBranchConfigsByNamesSuccess]: setCustomerLoadNumberByBranchConfigs,
  // public clo
  [A.getBranchConfigsWithPublicCloDataSuccess]: getBranchConfigsWithPublicCloDataSuccess,
  // order quote
  [A.getBranchConfigsWithOrderQuoteDataSuccess]: getBranchConfigsWithOrderQuoteDataSuccess,
  // transportation mode grouping
  [A.getTransportationModeGroupingListSuccess]: getTransportationModeGroupingListSuccess,
  // ai recognize
  [A.aiRecognizeSuccess]: aiRecognizeSuccess,
  [A.fetchStopLatLonSuccess]: fetchStopLatLonSuccess,
  // calculate eta
  [A.setETAConfigList]: setETAConfigList,
  [A.calculateEtaSuccess]: calculateEtaSuccess,
}, getInitialState(PAGE_TYPE_CREATE_DO));
